import { API_CONFIG } from '../config/urls'

export const API_BASE_URL = API_CONFIG.BASE_URL
export const ADMIN_URL = API_CONFIG.ADMIN_URL

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const

export const ERROR_MESSAGES = {
  [HTTP_STATUS.UNAUTHORIZED]: 'Your session has expired. Please sign in again.',
  [HTTP_STATUS.FORBIDDEN]: 'You do not have permission to perform this action.',
  [HTTP_STATUS.NOT_FOUND]: 'The requested resource was not found.',
  [HTTP_STATUS.INTERNAL_SERVER_ERROR]: 'An unexpected error occurred. Please try again later.',
  DEFAULT: 'Something went wrong. Please try again.',
  NETWORK_ERROR: 'Unable to connect to the server. Please check your internet connection.',
} as const